document.addEventListener('DOMContentLoaded', () => {
    // Disable right-click on images
    document.addEventListener('contextmenu', (e) => {
        if (e.target.tagName === 'IMG') {
            e.preventDefault();
        }
    });

    // Disable drag and drop
    document.addEventListener('dragstart', (e) => {
        if (e.target.tagName === 'IMG') {
            e.preventDefault();
        }
    });

    // Disable keyboard shortcuts
    document.addEventListener('keydown', (e) => {
        // Prevent Ctrl/Cmd + S, Ctrl/Cmd + C
        if ((e.ctrlKey || e.metaKey) && (e.key === 's' || e.key === 'c')) {
            e.preventDefault();
        }
    });

    // Optional: Disable selecting images
    const images = document.getElementsByTagName('IMG');
    Array.from(images).forEach(img => {
        img.style.userSelect = 'none';
        img.style.webkitUserSelect = 'none';
    });
});
